const otherOption = (options) => {
  return options?.find((option) => option?.keyName === 'other')?.name || ''
}

export default otherOption
